import { useState, useRef, useEffect } from "react";
import styles from "./Accordion.module.css";

export default function Accordion({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (isOpen && contentRef.current) {
      contentRef.current.style.maxHeight = contentRef.current.scrollHeight + "px";
    } else if (contentRef.current) {
      contentRef.current.style.maxHeight = "0px";
    }
  }, [isOpen]);

  return (
    <div className={styles.accordion}>
      <button
        className={styles.title}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        {title}
        <span className={styles.icon}>{isOpen ? "−" : "+"}</span>
      </button>
      <div
        ref={contentRef}
        className={`${styles.content} ${isOpen ? styles.open : ""}`}
      >
        {children}
      <div className={styles.spacer} aria-hidden />
      </div>
    </div>
  );
}
